import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="container mx-auto p-6 text-gray-800">
            <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
            <p>This privacy policy applies to the Qeza Care app ("Application") for mobile devices that was created by PT QEZA ESTETIKA MEDIKA ("Service Provider") as a Free service. This service is intended for use "AS IS".</p>

            <h2 className="text-2xl font-semibold mt-6">Information Collection and Use</h2>
            <p>The Application collects information when you download and use it, including:</p>
            <ul style={{ listStyleType: 'disc', listStylePosition: 'inside', marginLeft: '1rem', marginBottom: '1rem' }}>
                <li>Your device's Internet Protocol address (e.g. IP address)</li>
                <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
                <li>The time spent on the Application</li>
                <li>The operating system you use on your mobile device</li>
            </ul>
            <p>The Application does not gather precise location information.</p>

            <h2 className="text-2xl font-semibold mt-6">Third Party Access</h2>
            <p>The Application may share anonymized data with third parties for improving services. The third-party services used include:</p>
            <ul style={{ listStyleType: 'disc', listStylePosition: 'inside', marginLeft: '1rem', marginBottom: '1rem' }}>
                <li>Google Play Services</li>
                <li>Google Analytics for Firebase</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6">Opt-Out Rights</h2>
            <p>You can stop data collection by uninstalling the Application.</p>

            <h2 className="text-2xl font-semibold mt-6">Data Retention Policy</h2>
            <p>User Provided data is retained as long as you use the Application. To request deletion, contact <a href="mailto:qeza.it@gmail.com" className="text-blue-500">qeza.it@gmail.com</a>.</p>

            <h2 className="text-2xl font-semibold mt-6">Children</h2>
            <p>The Application does not target children under 13, and personal data from children under 13 is not knowingly collected.</p>

            <h2 className="text-2xl font-semibold mt-6">Security</h2>
            <p>The Service Provider implements safeguards to protect user data.</p>

            <h2 className="text-2xl font-semibold mt-6">Changes</h2>
            <p>This policy may be updated. Users should review it periodically.</p>

            <h2 className="text-2xl font-semibold mt-6">Your Consent</h2>
            <p>By using the Application, you consent to this Privacy Policy.</p>

            <h2 className="text-2xl font-semibold mt-6">Contact Us</h2>
            <p>For any privacy concerns, contact <a href="mailto:qeza.it@gmail.com" className="text-blue-500">qeza.it@gmail.com</a>.</p>
        </div>
    );
};

export default PrivacyPolicy;
